import $ from "jquery";
import { setCSRFheaders, generateRecaptchaToken, getCurrentPage } from "./es6/utils.js";
import {
    BUSINESS_IDENTIFIER_MINLEN,
    BUSINESS_IDENTIFIER_MAXLEN,
} from "./es6/constants.js";
import { removeBrowserSupport } from "./es6/support.js";
import { passwordStrengthChecker } from './es6/passwordStrengthChecker.js';
import { trackSignup } from "./es6/tracking.js";

/* VALIDATE EMAIL */
function isValidEmailAddress(emailAddress) {
    var pattern = new RegExp(
        /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i
    );
    return pattern.test(emailAddress);
}


$(document).ready(async function () {
    const currentPage = getCurrentPage();

    if (currentPage && currentPage.length > 0) {
        generateRecaptchaToken(currentPage)
    } else {
        generateRecaptchaToken('preapp')
    }
})

/* QUICK SIGNUP INDIVIDUAL CHECKBOX */
$("body").on("change", '[name="individual"]', function () {
    "use strict";

    $('[name="quick_signup_various[business_name]"]').val("");

    if ($(this).prop("checked") === true) {
        $('[name="quick_signup_various[business_name]"]').addClass("disabled");
        $('[name="quick_signup_various[business_name]"]').attr(
            "disabled",
            "disabled"
        );
    } else {
        $('[name="quick_signup_various[business_name]"]').removeAttr(
            "disabled"
        );
        $('[name="quick_signup_various[business_name]"]').removeClass(
            "disabled"
        );
    }
});

/* QUICK SIGNUP SWITCH BETWEEN SIGNUP AND LOGIN */
$("body").on("click", ".choice a", function () {
    $("body").find(".choice a").removeClass("selected");
    $(this).addClass("selected");

    var chosen = $(this).attr("data-choice");

    $("body").find("form[data-this-choice]").hide();
    $("body")
        .find('form[data-this-choice="' + chosen + '"]')
        .fadeIn();
});

/* QUICK SIGNUP VARIOUS */
$("body").on("submit", '[name="quick_signup_various"]', function (event) {
    event.preventDefault();
    $("body").find("p.errors").hide();

    var emailInput = $(this).find('[name="quick_signup_various[email]"]');
    var firstNameInput = $(this).find(
        '[name="quick_signup_various[first_name]"]'
    );
    var lastNameInput = $(this).find(
        '[name="quick_signup_various[last_name]"]'
    );
    var passwordInput = $(this).find('[name="quick_signup_various[password]"]');
    var businessNameInput = $(this).find(
        '[name="quick_signup_various[business_name]"]'
    );
    var vanityURLInput = $(this).find(
        '[name="quick_signup_various[vanity_url]"]'
    );

    var predefinedRedirectURL = $("body").find('[name="u"]').val();

    var planID = $("body").find('[name="plan_id"]').val();

    var signupRefID = $(this).find('[name="ref_id"]').val();
    var signupUtmSource = $(this).find('[name="utm_source"]').val();
    var signupUtmCampaign = $(this).find('[name="utm_campaign"]').val();
    var quickSignupID = $(this).attr("data-quick-signup-id");

    const vanityURLInputVal = vanityURLInput.val();

    // validation
    var error = false;

    if (!firstNameInput.val()) {
        error = true;
        firstNameInput.addClass("error");
    } else {
        firstNameInput.removeClass("error");
    }

    if (!lastNameInput.val()) {
        error = true;
        lastNameInput.addClass("error");
    } else {
        lastNameInput.removeClass("error");
    }

    if (!passwordInput.val()) {
        error = true;
        passwordInput.addClass("error");
    } else {
        if (passwordInput.val().length < 6) {
            passwordInput
                .closest(".form_row")
                .find("span.error")
                .html("Minimum 6 characters");
            passwordInput.addClass("error");
        } else {
            passwordInput.closest(".form_row").find("span.error").html("");
            passwordInput.removeClass("error");
        }
    }

    if (!isValidEmailAddress(emailInput.val())) {
        error = true;
        emailInput.addClass("error");
    } else {
        emailInput.removeClass("error");
    }
    
    if (!vanityURLInputVal) {
        error = true;
        vanityURLInput.addClass("error");
    } else {
        $("span.info").html("Your Xodo Sign URL");
        $('[name="quick_signup_various[vanity_url]"]').removeClass("error");

        if (/^[a-zA-Z0-9]+$/.test(vanityURLInputVal) == false) {
            error = true;
            $('[name="quick_signup_various[vanity_url]"]').addClass("error");
            $("span.info").html("No special characters allowed");
        } else {
            if (
                vanityURLInputVal.length < BUSINESS_IDENTIFIER_MINLEN ||
                vanityURLInputVal.length > BUSINESS_IDENTIFIER_MAXLEN
            ) {
                error = true;
                $('[name="quick_signup_various[vanity_url]"]').addClass(
                    "error"
                );
                $("span.info").html(
                    `Between ${BUSINESS_IDENTIFIER_MINLEN} and ${BUSINESS_IDENTIFIER_MAXLEN} characters`
                );
            }
        }
    }

    if (
        !businessNameInput.val() &&
        $('[name="individual"]').prop("checked") !== true
    ) {
        error = true;
        businessNameInput.addClass("error");
    } else {
        businessNameInput.removeClass("error");
    }

    if (error === true) {
        return false;
    }

    var button = $(this).find('[data-loading="true"]');

    button.addClass("loading");

    const captchaToken = $('[name="recaptcha_token"]').val();

    const promotionalEmailCheckbox = document.getElementById(
        'promotional_emails_consent',
    )
    const hasPromotionalEmailConsent =
        promotionalEmailCheckbox && promotionalEmailCheckbox.checked


    // build POST array
    var postData = {
        plan_id: planID,
        first_name: firstNameInput.val(),
        last_name: lastNameInput.val(),
        email_address: emailInput.val(),
        password: passwordInput.val(),
        business_name: businessNameInput.val(),
        business_vanity_name: vanityURLInput.val(),
        tos_accepted: 1,
        no_business: $('[name="individual"]').prop("checked") === true ? 1 : 0,
        quick_signup: 1,
        signup_src_id: signupRefID,
        utm_source: signupUtmSource,
        utm_campaign: signupUtmCampaign,
        payment_frequency: "yearly", // for potential normal paid signups (non-trial)
        token: captchaToken,
        promotional_emails_consent: hasPromotionalEmailConsent
    };

    var postDataJSON = JSON.stringify(postData);
    //console.log(postDataJSON);
    setCSRFheaders();

    const assetsUrl =  $('input[name=assets_url]').val();
    
    const signupEndpointURL = quickSignupID === 'trial'
        ? `${assetsUrl}/middleware/account/create`
        : '/php/public_ajax_handler.php?type=create_account';
    
    $.ajax({
        type: 'POST',
        url: signupEndpointURL,
        data: { postArray: postDataJSON },
        dataType: 'json',
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            //alert(textStatus + ', ' + errorThrown);
            generateRecaptchaToken("preapp_create_account_error");
        },
        success: function (data) {
            if (data.success === 1) {
                $('body')
                    .find('p.errors')
                    .show()
                    .addClass('green')
                    .html('Redirecting ...')

                // Disable the button and change its background color
                $('body').find('.finish_signup')
                .prop('disabled', true)
                .css({
                    'cursor': 'not-allowed',
                    'opacity': '0.5'
                });


                var baseURL = data.message.base_url
                var redirectTo
                var realRedirectURL

                switch (quickSignupID) {
                    case 'trial':
                        realRedirectURL = encodeURIComponent('https://' + baseURL + '/dashboard',)
                        trackSignup('trial_signup');
                    break
                    case 'quick_signup_docracy':
                        realRedirectURL = encodeURIComponent(predefinedRedirectURL)
                    break
                    case 'normal':
                        if (data.message.payment_required == 1) {
                            realRedirectURL = encodeURIComponent('https://' + baseURL + '/checkout/' + data.message.invoice_id,)
                        } else {
                            realRedirectURL = encodeURIComponent('https://' + baseURL + '/dashboard',)
                        }
                    break
                    default:
                        realRedirectURL = encodeURIComponent('https://' + baseURL + '/dashboard',)
                    break
                }

                redirectTo = 'https://' +
                                baseURL +
                                '/perform_login?email_address=' +
                                encodeURIComponent(emailInput.val()) +
                                '&one_time_signin_key=' +
                                data.message.one_time_signin_key +
                                '&redirect_url=' +
                                realRedirectURL

                window.location.href = redirectTo
                return false
            } else {
                $('body').find('p.errors').show().html(data.message);
                generateRecaptchaToken("preapp_create_account_success_false");
            }

            button.removeClass('loading')
        },
    })
});

document.addEventListener("DOMContentLoaded", function () {
    const isLogginPage = document.body.classList.contains("login");
    const isTrialPage = $('html').hasClass('trial');

    if (isLogginPage) {
        removeBrowserSupport();
    }

    if (isTrialPage) { 
		passwordStrengthChecker();
	}
});
